// src/form/AIPricingFormEntry.tsx
import AIPricingForm from "./components/ai-pricing-form"

const AIPricingFormEntry = () => {
  return <AIPricingForm />
}

export default AIPricingFormEntry